import(/* webpackMode: "eager" */ "/app/node_modules/@codegouvfr/react-dsfr/assets/dsfr_plus_icons.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@codegouvfr/react-dsfr/dsfr/favicon/apple-touch-icon.png");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@codegouvfr/react-dsfr/dsfr/favicon/favicon.ico");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@codegouvfr/react-dsfr/dsfr/favicon/favicon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["DsfrProvider"] */ "/app/node_modules/@codegouvfr/react-dsfr/next-appdir/DsfrProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/remixicon/fonts/remixicon.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-datepicker/dist/react-datepicker.css");
;
import(/* webpackMode: "eager", webpackExports: ["StartDsfr"] */ "/app/ui/app/_dsfr-setup/start-dsfr.tsx");
;
import(/* webpackMode: "eager" */ "/app/ui/app/global.css");
;
import(/* webpackMode: "eager" */ "/app/ui/app/_styles/month-select.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/ui/components/RateLimitBanner.tsx");
